var AnnouncementSlider = new Swiper(".announcement-slider", {
  loop:false,
  slidesPerView: 1,  
  spaceBetween: 15,
  // autoplay: {
  //   delay: 4000,
  // }
});


var HeroSection = new Swiper(".hero-slider", {
  loop:true,
  slidesPerView: 1,
  spaceBetween: 15,
  autoHeight: true, 
  autoplay: {
    delay: 5000,
  }
});


var CustomCollectionList = new Swiper(".collection-card-slider", {
  loop:false, 
  slidesPerView: 1.3, 
  spaceBetween: 15,
  breakpoints: {
    750: {
      slidesPerView: 2,
      spaceBetween: 15
    },
    900: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 24
    }
  }
});



var CereriamollaColumnsSlider = new Swiper(".cereria-molla-columns-slider", {
  loop:false, 
  slidesPerView: 1.3, 
  spaceBetween: 15,
  breakpoints: {
    750: {
      slidesPerView: 2,
      spaceBetween: 15
    },
    989: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 50
    }
  }
});


var CustomCollectionListviewPDPCAED = new Swiper(".custom-collection-pdpcard-row-view", {
  loop:false,
  slidesPerView: 1.3,
  spaceBetween: 15,
  navigation: {
    nextEl: ".custom-featured-collection-section .section-type-type_1 .swiper-button-next",
    prevEl: ".custom-featured-collection-section .section-type-type_1 .swiper-button-prev"
  },
  breakpoints: {
    900: {
      slidesPerView: 1.8,
      spaceBetween: 20
    },
    1200: {
      slidesPerView: 2.6,
      spaceBetween: 20
    }
  }
});



var CustomCollectionGridviewPDPCAED = new Swiper(".custom-collection-pdpcard-column-view", {
  loop:false,
  slidesPerView: 1.3,
  spaceBetween: 15,
  breakpoints: {
    750: {
      slidesPerView: 2,
      spaceBetween: 15
    },
    900: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 20
    }
  }
});


var CustomCollectionGridviewPDPCAED = new Swiper(".custom-collection-pdpcard-column-view3", {
  loop:false,
  slidesPerView: 1.3,
  spaceBetween: 15,
  navigation: {
    nextEl: ".custom-featured-collection-section .section-type-type_3 .swiper-button-next",
    prevEl: ".custom-featured-collection-section .section-type-type_3 .swiper-button-prev"
  },
  breakpoints: {
    750: {
      slidesPerView: 2,
      spaceBetween: 15
    },
    900: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 20
    }
  }
});


let inner_cols = document.querySelectorAll('.inner-col');
inner_cols.forEach((inner_col)=>{
    inner_col.addEventListener('mouseenter',()=>{
      let btn_handle = inner_col.dataset.mmProduct;
      if(btn_handle){
        let inner_col_containor = inner_col.closest('.custom-mm-column-wrap');
         if(inner_col_containor){
             let match_cards = inner_col_containor.querySelectorAll(`.mm-product-card-list[data-mm-product="${btn_handle}"]`);
            if(match_cards && match_cards.length){
                let same_tab_cards = inner_col_containor.querySelectorAll('.mm-product-card-list');
                same_tab_cards.forEach((same_tab_card)=>same_tab_card.classList.remove('active'));
                match_cards.forEach((match_card)=>match_card.classList.add('active'));
            }
         }
      }
    })
})

let activate_first_card =()=>{
    let custom_mm_column_wraps = document.querySelectorAll('.custom-mm-column-wrap');
    custom_mm_column_wraps.forEach((custom_mm_column_wrap)=>{
        let first_inner_col = custom_mm_column_wrap.querySelector('.inner-col');
        if(first_inner_col){
             let first_inner_col_handle = first_inner_col.dataset.mmProduct;
             if(first_inner_col_handle){
                let match_cards = custom_mm_column_wrap.querySelectorAll(`.mm-product-card-list[data-mm-product="${first_inner_col_handle}"]`);   
                  if(match_cards && match_cards.length){
                        match_cards.forEach((match_card)=>match_card.classList.add('active'));
                    }
             }
        }
    })
}
activate_first_card();




var GalleryGridSlider1 = new Swiper(".section-first-slider", {
  loop:true,
  slidesPerView: 1,
  spaceBetween: 10,
  allowTouchMove: false, 
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: ".home-imagegrid-slider-section .swiper-button-next",
    prevEl: ".home-imagegrid-slider-section .swiper-button-prev"
  }
});
var GalleryGridSlider2 = new Swiper(".center-col-slider1", {
  loop:true,
  slidesPerView: 1,
  spaceBetween: 10,
  allowTouchMove: false, 
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: ".home-imagegrid-slider-section .swiper-button-next",
    prevEl: ".home-imagegrid-slider-section .swiper-button-prev"
  }
});

var GalleryGridSlider3 = new Swiper(".center-col-slider2", {
  loop:true,
  slidesPerView: 1,
  spaceBetween: 10,
  allowTouchMove: false, 
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: ".home-imagegrid-slider-section .swiper-button-next",
    prevEl: ".home-imagegrid-slider-section .swiper-button-prev"
  }
});

var GalleryGridSlider4 = new Swiper(".section-last-slider", {
  loop:true,
  slidesPerView: 1,
  spaceBetween: 10,
  allowTouchMove: false, 
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: ".home-imagegrid-slider-section .swiper-button-next",
    prevEl: ".home-imagegrid-slider-section .swiper-button-prev"
  }
});



var ArticleListSlider = new Swiper(".article-card-slider", {
  loop:true,
  slidesPerView: 1.3,
  spaceBetween: 15,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    750: {
      slidesPerView: 2,
      spaceBetween: 15
    },
    990: {
      slidesPerView: 3,
      spaceBetween: 20
    }
  }
});


document.querySelectorAll('.faqgroup-list').forEach(group => {
  const faqBlocks = group.querySelectorAll('.faq-block');
  faqBlocks.forEach(block => {
    block.querySelector('.faq-question').addEventListener('click', () => {
      const isActive = block.classList.contains('active');
      faqBlocks.forEach(item => item.classList.remove('active'));
      if (!isActive) {
        block.classList.add('active');
      }
    });
  });
});


var HomeIconlistSlider = new Swiper(".home-iconlist-slider", {
  loop:false,
  slidesPerView: 1.3,
  spaceBetween: 20,
  slidesPerView: "auto",
  breakpoints: {
    750: {
      slidesPerView: 2,
      spaceBetween: 15
    },
    900: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 20
    }
  }
});


document.querySelectorAll('.footer-block--menu .footer-block__heading').forEach((heading) => {
  heading.addEventListener('click', function () {
    this.classList.toggle('active');
  });
});


// collection page list view and grid view manage

document.addEventListener('DOMContentLoaded', function () {
  const gridViewBtn = document.querySelector('.grid-view-button');
  const listViewBtn = document.querySelector('.list-view-button');
  const savedView = localStorage.getItem('plp-view') || 'grid';
  applyView(savedView);
  if(!gridViewBtn && !listViewBtn)return;
  gridViewBtn.addEventListener('click', function () {
    applyView('grid');
    localStorage.setItem('plp-view', 'grid');
  });

  listViewBtn.addEventListener('click', function () {
    applyView('list');
    localStorage.setItem('plp-view', 'list');
  });

  function applyView(view) {
    const productGrid = document.querySelector('#product-grid');
    if (!gridViewBtn) return;
    if (!productGrid) return;


    if (view === 'list') {
      productGrid.classList.add('card-listview');
      productGrid.classList.remove('card-gridview');
      listViewBtn.classList.add('active');
      gridViewBtn.classList.remove('active');
    } else {
      productGrid.classList.add('card-gridview');
      productGrid.classList.remove('card-listview');
      gridViewBtn.classList.add('active');
      listViewBtn.classList.remove('active');
    }
  }
});


document.addEventListener('click', function(event) {
  if (
    event.target.closest('.cartnote-popup-close-icon') ||
    event.target.closest('.cart-note-popup-overlay') ||
    event.target.closest('.cartnote-close-button')
  ) {
    document.querySelector('.cartdrawer-edit-poppu-button')?.click();
  }
});


document.addEventListener("click", function (e) {
  if (e.target.closest(".cart-note-button-wrap")) {
    document.querySelector(".cartpage-note-popup")?.classList.add("active");
    document.querySelector(".cartpage-note-popup-overlay")?.classList.add("active");
  }
  if (
    e.target.closest(".cartpage-note-popup-overlay") ||
    e.target.closest(".cartnote-popup-close-icon-page") ||
    e.target.closest(".cartnote-close-button-page")
  ) {
    document.querySelector(".cartpage-note-popup")?.classList.remove("active");
    document.querySelector(".cartpage-note-popup-overlay")?.classList.remove("active");
  }

});



var BlogTagList = new Swiper(".blog-taglist", {
  loop:false,
  slidesPerView: "auto",
  spaceBetween: 10
});



document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll('.highlight-title-list a[href^="#"]');
  const headerHeight = parseInt(
    getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height')
  ) || 0;

  // Click Scroll
  links.forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const targetId = this.getAttribute("href");
      const target = document.querySelector(
        `.article-body ${targetId}`
      );

      if (!target) return;

      const offsetTop =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight;

      window.scrollTo({
        top: offsetTop,
        behavior: "smooth"
      });
    });
  });

  // Active Class on Scroll
  function updateActiveLink() {
    let currentId = "";

    document
      .querySelectorAll('.article-body [id]')
      .forEach(section => {
        const rect = section.getBoundingClientRect();

        if (rect.top <= headerHeight + 10) {
          currentId = section.id;
        }
      });

    links.forEach(link => {
      link.classList.remove("active");

      if (
        currentId &&
        link.getAttribute("href") === `#${currentId}`
      ) {
        link.classList.add("active");
      }
    });
  }

  window.addEventListener("scroll", updateActiveLink);
  updateActiveLink();
});




var homeCustomSlider = new Swiper(".hero-imagegrid-slider", {
  slidesPerView: 1,
  loop: true,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },

  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  speed: 800
});


document.addEventListener("click", function (e) {
  const icon = e.target.closest(".main-mm-icon");
  if (!icon) return;

  const dropdownId = icon.getAttribute("data-dropdown-id");
  if (!dropdownId) return;

  const targetMenu = document.querySelector(
    `.second-stap-menulist[data-dropdown-id="${dropdownId}"]`
  );

  if (targetMenu) {
    icon.classList.toggle("active");
    targetMenu.classList.toggle("active");
  }
});



document.addEventListener("click", function (e) {
  const main_tab_button = e.target.closest(".tab-main-button");
  if (!main_tab_button) return;
  const dropdownId = main_tab_button.getAttribute("main-tabname");
  document.querySelectorAll(".tab-main-button.active").forEach(el => {
    if (el !== main_tab_button) el.classList.remove("active");
  });
  document.querySelectorAll(".maintab-details.active").forEach(el => {
    if (el.getAttribute("main-tabname") !== dropdownId) {
      el.classList.remove("active");
    }
  });
  main_tab_button.classList.add("active");
  const targetMenu = document.querySelector(
    `.maintab-details[main-tabname="${dropdownId}"]`
  );
  if (targetMenu) {
    targetMenu.classList.add("active");
  }
});


function handleTabSwitch({
  buttonSelector,
  buttonAttr,
  targetSelector,
  targetAttr,
  scopeSelector
}) {
  document.addEventListener('click', (e) => {
    const button = e.target.closest(buttonSelector);

    if (!button) return;

    const scope = button.closest(scopeSelector);

    if (!scope) return;

    const targetId = button.getAttribute(buttonAttr);

    scope.querySelectorAll(`${buttonSelector}.active`).forEach((el) => {
      el.classList.remove('active');
    });

    scope.querySelectorAll(`${targetSelector}.active`).forEach((el) => {
      el.classList.remove('active');
    });

    button.classList.add('active');

    const target = scope.querySelector(
      `${targetSelector}[${targetAttr}="${targetId}"]`
    );

    if (target) {
      target.classList.add('active');
    }
  });
}

// Showroom / Warehouse / Distribution City
handleTabSwitch({
  buttonSelector: '.city-name-button',
  buttonAttr: 'data-citymap',
  targetSelector: '.city-map-list',
  targetAttr: 'data-citymap',
  scopeSelector: '.maintab-details'
});

// Distribution Sub Cities
handleTabSwitch({
  buttonSelector: '.distribution-city-list',
  buttonAttr: 'data-map-id',
  targetSelector: '.distribution-city-maplist',
  targetAttr: 'data-map-id',
  scopeSelector: '.city-map-list'
});

var YoutubeVideoSlider = new Swiper(".youtube-video-slider", {
  loop:false,
  slidesPerView: 1.3,
  spaceBetween: 20,
  slidesPerView: 1.2,
  navigation: {
    nextEl: ".youtube-video-slider-section .swiper-button-next",
    prevEl: ".youtube-video-slider-section .swiper-button-prev"
  },
  breakpoints: {
    750: {
      slidesPerView: 2,
      spaceBetween: 15
    },
    900: {
      slidesPerView: 2.4,
      spaceBetween: 20
    },
    1200: {
      slidesPerView: 3.3,
      spaceBetween: 20
    }
  }
});
function initProductMediaSlider(scope = document) {
  const wrappers = scope.querySelectorAll('.product-gallery-wrapper');

  wrappers.forEach((wrapper) => {
    const mainSlider = wrapper.querySelector('.product-media-slider');
    const thumbSlider = wrapper.querySelector('.product-thumb-slider');

    if (!mainSlider || mainSlider.swiper) return;

    let thumbsSwiper = null;

    if (thumbSlider && !thumbSlider.swiper) {
      thumbsSwiper = new Swiper(thumbSlider, {
        slidesPerView: 4,
        spaceBetween: 20,
        freeMode: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        watchOverflow: true,
      });
    } else {
      thumbsSwiper = thumbSlider?.swiper;
    }

    new Swiper(mainSlider, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      autoHeight: true,

      navigation: {
        nextEl: mainSlider.querySelector('.swiper-button-next'),
        prevEl: mainSlider.querySelector('.swiper-button-prev'),
      },

      pagination: {
        el: mainSlider.querySelector('.swiper-pagination'),
        clickable: true,
      },

      thumbs: thumbsSwiper
        ? {
            swiper: thumbsSwiper,
          }
        : undefined,

      on: {
        init() {
          handleVideo(this);
        },

        slideChangeTransitionEnd() {
          handleVideo(this);
        }
      }
    });
  });
}

// Initial Page Load
document.addEventListener('DOMContentLoaded', () => {
  initProductMediaSlider();
});

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (!(node instanceof HTMLElement)) return;

      if (
        node.matches('.product-media-slider') ||
        node.querySelector('.product-media-slider')
      ) {
        initProductMediaSlider(node);
      }
    });
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

function handleVideo(swiper) {
  // Pause all videos
  swiper.el.querySelectorAll('video').forEach((video) => {
    video.pause();
    video.currentTime = 0;
  });

  // Get current active DOM slide (works with loop)
  const activeSlide = swiper.slides[swiper.activeIndex];
  const activeVideo = activeSlide.querySelector('video');

  if (activeVideo) {
    activeVideo.play().catch(() => {});
  }
}

/* ------------------------------------------------------------------ *
 * Variant -> Gallery sync
 * Dawn's built-in product-info.js publishes PUB_SUB_EVENTS.variantChange
 * (globals `subscribe` / `PUB_SUB_EVENTS` come from theme assets
 * pubsub.js + constants.js, already loaded on every Dawn page).
 * We listen for that event, find the swiper-slide whose data-media-id
 * matches the newly selected variant's featured_media, and slide there.
 * ------------------------------------------------------------------ */
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variant = event?.data?.variant;
    if (!variant || !variant.featured_media) return;

    const sectionId = event?.data?.sectionId;

    document.querySelectorAll('.product-gallery-wrapper').forEach((wrapper) => {
      // Match the wrapper to the section that published the event.
      // Falls back to updating every gallery on the page if no
      // shopify-section ancestor / sectionId is found (safe for
      // single-product pages, quick-view, etc).
      if (sectionId) {
        const section = wrapper.closest('[id^="shopify-section-"]');
        if (section && section.id !== `shopify-section-${sectionId}`) return;
      }

      const mainSlider = wrapper.querySelector('.product-media-slider');
      if (!mainSlider || !mainSlider.swiper) return;

      const targetSlide = mainSlider.querySelector(
        `.swiper-slide[data-media-id="${variant.featured_media.id}"]`
      );
      if (!targetSlide) return;

      const targetIndex = Array.from(mainSlider.querySelectorAll('.swiper-slide')).indexOf(
        targetSlide
      );
      if (targetIndex === -1) return;

      mainSlider.swiper.slideTo(targetIndex);
      // Thumb slider auto-syncs via the `thumbs` module, no extra call needed.
    });
  });
}

document.addEventListener('click', function (e) {
  const tabButton = e.target.closest('.pdp-tab-header-button');
  if (!tabButton) return;
  const tabName = tabButton.getAttribute('data-pdptab-name');
  if (!tabName) return;
  document.querySelectorAll('.pdp-tab-header-button').forEach((btn) => {
    btn.classList.remove('active');
  });

  tabButton.classList.add('active');
  document.querySelectorAll('.pdp-tab-body').forEach((body) => {
    body.classList.remove('active');

    if (body.getAttribute('data-pdptab-name') === tabName) {
      body.classList.add('active');
    }
  });
});




// Zoom Popup Slider
const ProductZoomSlider = new Swiper(".product-zoom-slider", {
  loop: false,
  autoHeight: true,
  slidesPerView: 1,
  spaceBetween: 10,
  allowTouchMove: true,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: ".product-zoom-popup .swiper-button-next",
    prevEl: ".product-zoom-popup .swiper-button-prev",
  },
  pagination: {
    el: ".product-zoom-popup .swiper-pagination",
    clickable: true,
  },
});

// Open Popup
document.addEventListener("click", function (e) {
  const opener = e.target.closest(".product-zoom-popup-opner");
  if (!opener) return;

  const popup = document.querySelector(".product-zoom-popup");
  const overlay = document.querySelector(".product-zoom-overlay");

  popup?.classList.add("active");
  overlay?.classList.add("active");
  document.body.classList.add("pdp-zoom-popup-open");

  // Get slide index (1-based -> 0-based)
  const index = parseInt(opener.getAttribute("zoom-button-index"), 10) - 1;

  // Refresh Swiper
  ProductZoomSlider.update();
  ProductZoomSlider.slideTo(index, 0);
});

// Close Popup
document.addEventListener("click", function (e) {
  if (
    e.target.closest(".product-zoom-overlay") ||
    e.target.closest(".popup-close-button")
  ) {
    document.querySelector(".product-zoom-popup")?.classList.remove("active");
    document.querySelector(".product-zoom-overlay")?.classList.remove("active");
    document.body.classList.remove("pdp-zoom-popup-open");
  }
});


document.addEventListener('DOMContentLoaded', () => {
  // Homepage only + Desktop only
  if (window.location.pathname !== '/' || window.innerWidth < 1260) return;

  const megaMenus = document.querySelectorAll('header-menu details');

  megaMenus.forEach((menu) => {
    let timeout;

    menu.addEventListener('mouseenter', () => {
      clearTimeout(timeout);
      menu.setAttribute('open', '');
    });

    menu.addEventListener('mouseleave', () => {
      timeout = setTimeout(() => {
        menu.removeAttribute('open');
      }, 150);
    });
  }); 
});

function initRelatedProductsSwiper() {
  const slider = document.querySelector('.related-product-swiper');
  if (!slider || slider.swiper) return;
  new Swiper(slider, {
    slidesPerView: 4,
    spaceBetween: 20,

    navigation: {
      nextEl: slider.querySelector('.swiper-button-next'),
      prevEl: slider.querySelector('.swiper-button-prev')
    },

    breakpoints: {
      0: {
        slidesPerView: 1.2
      },
      480: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      990: {
        slidesPerView: 4
      }
    }
  });
}
document.addEventListener('DOMContentLoaded', initRelatedProductsSwiper);
const swiperObserver = new MutationObserver(() => {
  initRelatedProductsSwiper();
});

swiperObserver.observe(document.body, {
  childList: true,
  subtree: true
});



document.addEventListener("click", function (e) {
  const predictiveSearch = document.querySelector("predictive-search");

  if (!predictiveSearch) return;

  if (!predictiveSearch.contains(e.target)) {
    predictiveSearch.close?.();
  }
});



document.addEventListener("DOMContentLoaded", () => {
  const openButtons = document.querySelectorAll(".b2b-poppu-opener-button");
  const popup = document.querySelector(".b2b-form-popup");
  const overlay = document.querySelector(".b2b-form-overlay");
  const closeButton = document.querySelector(".popup-close-button");
  const body = document.body;

  if (!openButtons) return;

  // Open Popup
  openButtons.forEach(button => {
    button.addEventListener("click", (e) => {
      e.preventDefault();

      popup?.classList.add("active");
      overlay?.classList.add("active");
      body.classList.add("b2b-popup-open");
    });
  });

  // Close Popup Function
  const closePopup = () => {
    popup?.classList.remove("active");
    overlay?.classList.remove("active");
    body.classList.remove("b2b-popup-open");
  };

  // Close on Overlay Click
  overlay?.addEventListener("click", closePopup);

  // Close on Close Button Click
  closeButton?.addEventListener("click", closePopup);
});



function initCereriaMollaFragrance() {
  const slider = document.querySelector(".cereria-molla-fragrance-slider");
  if (!slider) return;

  const fragranceRows = document.querySelectorAll(".fragrance-row");
  const fragranceSlides = document.querySelectorAll(".fragrance-slide");

  let swiperInstance = null;
  let resizeTimer;

  function setActiveRow(rowKey) {
    fragranceRows.forEach(function (row) {
      row.classList.toggle("active", row.dataset.row === rowKey);
    });
  }

  function bindSlideChange() {
    swiperInstance.on("slideChange", function () {
      const activeSlide = fragranceSlides[swiperInstance.activeIndex];
      if (activeSlide) setActiveRow(activeSlide.dataset.row);
    });
  }

  function initializeSwiper() {
    const isDesktop = window.innerWidth >= 990;

    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }

    swiperInstance = new Swiper(".cereria-molla-fragrance-slider", isDesktop
      ? {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 0,
          effect: "fade",
          fadeEffect: { crossFade: true }
        }
      : {
          loop: false,
          slidesPerView: 1.4,
          spaceBetween: 15,
          effect: "slide"
        }
    );

    bindSlideChange();
  }

  initializeSwiper();

  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initializeSwiper, 250);
  });

  // Row hover -> active class + slider move
  fragranceRows.forEach(function (row) {
    row.addEventListener("mouseenter", function () {
      const rowKey = row.dataset.row;
      setActiveRow(rowKey);

      const slideIndex = Array.prototype.findIndex.call(fragranceSlides, function (slide) {
        return slide.dataset.row === rowKey;
      });

      if (slideIndex > -1 && swiperInstance) {
        swiperInstance.slideTo(slideIndex);
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", initCereriaMollaFragrance);